import React, { useState, forwardRef } from "react";
import { InputProps } from "./Input.props";
import P from "../P/P";
import SvgIcon from "../SvgIcon/SvgIcon";
import { EyeCloseIcon, EyeOpenIcon } from "@assets/icons";

const Input = forwardRef<HTMLInputElement, InputProps>(
	(
		{
			type = "text",
			label,
			error,
			onChange,
			containerClassName = "",
			inputClassName = "",
			labelClassName = "",
			text = "text-light-textColor dark:text-dark-textColor",
			leftIcon,
			rightIcon, // ✅ new prop
			...props
		},
		ref,
	) => {
		const [showPassword, setShowPassword] = useState(false);

		const togglePasswordVisibility = () => {
			setShowPassword((prev) => !prev);
		};

		const inputType =
			type === "password" && !showPassword ? "password" : "text";

		return (
			<div className={`flex flex-col gap-1 ${containerClassName}`}>
				{label && (
					<P
						size="t1"
						type="regular"
						className={`text-${text} ${labelClassName}`}
					>
						{label}
					</P>
				)}

				<div className="relative grid grid-cols-1 w-full items-center">
					{leftIcon && <span className="absolute left-3">{leftIcon}</span>}

					<input
						ref={ref}
						type={inputType}
						onChange={onChange}
						className={`input border border-stroke rounded-lg py-2 px-4 ${
							leftIcon ? "pl-10" : "pl-4"
						} ${
							type === "password" || rightIcon ? "pr-10" : "pr-4"
						} dark:text-dark-textColor text-light-textColor focus:outline-none transition-all duration-300 ease-in-out hover:border-shadeOne focus:border-shadeOne focus:ring-0 focus:ring-transparent bg-light-bgColor dark:bg-dark-bgColor ${inputClassName} ${
							error ? "border-red-500 focus:ring-red-500" : ""
						}`}
						{...props}
					/>

					{/* Password visibility toggle */}
					{type === "password" && (
						<span
							className="absolute cursor-pointer right-3"
							onClick={togglePasswordVisibility}
						>
							<SvgIcon Icon={showPassword ? EyeOpenIcon : EyeCloseIcon} />
						</span>
					)}

					{/* ✅ Custom rightIcon */}
					{rightIcon && type !== "password" && (
						<span className="absolute right-3">{rightIcon}</span>
					)}
				</div>

				{error && <p className="mt-1 text-sm text-red-500">{error}</p>}
			</div>
		);
	},
);

export default React.memo(Input);
